import React, { FC, useMemo, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { SingleValue } from 'react-select';
import classNames from 'classnames';
import { AsyncPaginate } from 'react-select-async-paginate';
import { getLoadUserOptions } from '@/apps/Applications/helpers';
import { Events, State } from '@/interfaces';
import styles from '../../styles/index.module.scss';
import { customMultiSelectUserStyles } from '../../../../consts';

interface ISelectUser {
	className?: string,
	value: any,
	onChange: ( e: SingleValue<{ value: number; label: string }> ) => void;
	flagDisabled: boolean,
	width?: number | string,
	maxWidth?: number | string,
}

const SelectUser: FC<ISelectUser> = ( props ) => {
	const {
		value,
		onChange,
		className,
		flagDisabled,
		width = '100%',
		maxWidth = '100%'
	} = props;

	const { typeOrder } = useStoreon<State, Events>('typeOrder');
	const [inputValue, setInputValue] = useState('');

	const loadOptions = (search: string) => {
    return getLoadUserOptions({search, typeOrder})
  }

	const selectStyles = {
		...customMultiSelectUserStyles,
		control: ( provided: Record<string, any> ) => ({
			...provided,
			width,
			maxWidth,
			// flexWrap: 0,
			flexFlow: 'initial',
			'@media screen and (max-width:810px)': {
				width: '100%'
			}
		}),
		container: ( provided: Record<string, any> ) => ({
			...provided,
			width,
			maxWidth,
			'@media screen and (max-width:810px)': {
				width: '100%'
			}
		}),
	};

	useMemo(() => {
		if (value) {
			setInputValue('');
		}
	}, [value]);


	return (
		<AsyncPaginate
			isClearable
			placeholder="Выберите"
			loadOptions={loadOptions}
			onChange={( event: any ) => onChange(event)}
			onInputChange={( event: any, { action } ) => {
				if (action === 'menu-close' || action === 'input-blur') return false;
				return setInputValue(event);
			}}
			inputValue={inputValue}
			debounceTimeout={500}
			value={[value]}
			additional={{ page: 1 }}
			isDisabled={flagDisabled}
			noOptionsMessage={() => 'Ничего не найдено'}
			loadingMessage={() => 'Поиск...'}
			className={classNames(styles[ 'item-select' ], className)}
			styles={selectStyles}
			name="customer"
		/>
	);
};

export default SelectUser;